// extracted by mini-css-extract-plugin
export default {"outsideanchor":"OutsideAnchor_outsideanchor__on5+U","outsideanchor_icon":"OutsideAnchor_outsideanchor_icon__64Q-L"};